<template>
  <div class="resDetail">
  <AgreementDetal/>
  </div>
</template>

<script>
    import AgreementDetal from '@/components/AgreementDetail.vue'
    export default{
        components: { AgreementDetal },
    }
</script>